import { axios } from '@ben/api/axios';
import { BaseAIAction } from '@ben/columbia/components/assistant/actions/base';
import {
  FollowUpType,
  InvalidArgumentError,
} from '@ben/columbia/components/assistant/types';

interface BenefitDescriptionResponse {
  description?: string;
}

export class CreateBenefitDescription extends BaseAIAction {
  language: string;

  constructor(language: string) {
    super();
    this.language = language;
    this.label = 'Create Description';
    this.requiresUserPrompt = true;
    this.firstMessage = 'Please provide a description for the benefit';
  }

  override async trigger(): Promise<[FollowUpType, unknown][]> {
    if (!this.args || this.args.length !== 1) {
      throw InvalidArgumentError;
    }

    const response = await axios.post<BenefitDescriptionResponse>(
      'assistant/',
      {
        toolName: 'createBenefitDescription',
        request: this.args[0],
        language: this.language,
      },
      {
        baseURL: `${process.env.REACT_APP_API_URL}api/v1.0/`,
      }
    );

    if (!response.data.description) {
      return [
        [
          FollowUpType.ChatMessage,
          'I could not generate a description for the benefit. Please try again.',
        ],
        [FollowUpType.ContinueConversation, []],
      ];
    }

    return [
      [FollowUpType.UpdateInput, response.data.description],
      [FollowUpType.SetExecuted, []],
      [FollowUpType.SetTerminal, []],
    ];
  }
}
